module.exports = __webpack_public_path__ + "img/hq-2026-mobile.90e373d2.jpg";